import { Globe } from 'lucide-react';

import { ConfirmDialog } from '@/_shared/components/ConfirmDialog';

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  pending?: boolean;
}

/** Confirmation before flipping a dashboard public. The copy is deliberately blunt — dashboards re-run
 * their queries on every load, so a panel that "looked safe" against today's data may surface PII
 * tomorrow. Default focus stays on Keep private to make the safe path the easy one. */
export function PublishConfirmDialog({ open, onConfirm, onCancel, pending = false }: Props): React.ReactElement {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(next) => !next && onCancel()}
      destructive={false}
      title={
        <span className="flex items-center gap-2">
          <Globe className="size-5" /> Publish dashboard to the web
        </span>
      }
      description={
        <span className="block space-y-3">
          <span className="block">
            Anyone with this link can open it without signing in, including people outside your workspace. Search
            engines may index it. You can disable the link later, but you can&apos;t un-share what&apos;s been seen.
          </span>
          <span className="block">
            Dashboards re-run queries on every load. Make sure it doesn&apos;t expose PII, revenue, or sensitive
            customer data.
          </span>
        </span>
      }
      cancelLabel="Keep private"
      confirmLabel="Publish to the web"
      loading={pending}
      onConfirm={onConfirm}
    />
  );
}
